module.exports = __webpack_public_path__ + "img/fdj-01.80518e67.png";